<template>
    <el-dialog
      v-if="visible"
      :title="title"
      :visible.sync="visible"
      width="60%"
      :append-to-body="true"
      @close="closeDialog"
    >
          <avue-crud
            :option="option"
            :table-loading="loading"
            :data="data"
            :page.sync="page"
            ref="crud"
            @on-load="onLoad"
            @current-change="currentChange"
            @size-change="sizeChange"
            @refresh-change="onLoad"
          >

          </avue-crud>
    </el-dialog>

</template>
<script>


import {
  invoiceOperateLogPage,
} from "@/api/v4ward/digitaltickets/taxinvoicerecord/TaxInvoiceRecord";

export default {
  components: {

  },
  props: {
    feePayId:'',
    visible:false,
  },
  data() {
    return {
      data:[],
      title:'操作日志',
      option: {
        index: true,
        indexLabel: '序号',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'center',
        refreshBtn: false,
        viewBtn: false,
        searchBtn:false,
        columnBtn:false,
        searchShowBtn:false,
        menu: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '操作类型',
            prop: 'operateType',
            dicData: [
              { label: '蓝票红冲', value: 'RED' },
              { label: '蓝票开具', value: 'BLUE' },
              { label: '收据打印', value: 'PRINT' },
              { label: '申请退款', value: 'REFUND_APPLY' },
              { label: '退款审核同意', value: 'REFUND_AGREE' },
              { label: '退款审核拒绝', value: 'REFUND_REJECT' },
            ],
            width: 110,
          },{
            label: '操作内容',
            prop: 'operateContent',
          },
          {
            label: '操作时间',
            prop: 'operateTime',
            width: 150,
          },
          {
            label: '操作人',
            prop: 'operatorName',
            width: 110,
          },
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
    };
  },
  watch:{
  },
  created() {
  },
  methods: {
    closeDialog(){
      this.visible = false;
      this.$emit('close');
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad() {
      this.loading = true;
      if(this.feePayId){
        invoiceOperateLogPage(Object.assign({},{ current: this.page.currentPage, size: this.page.pageSize }, {targetIds:this.feePayId})).then(({data})=>{
          this.data = data.records
          this.page.total = data.total
          this.loading = false;
        }).catch(()=>{
          this.loading = false;
        })
      }
    },
  },
};
</script>
<style>

</style>
